module.exports = __webpack_public_path__ + "img/link_007.0ecd37df.png";